import Observer from './Helpers/Observer';

const observer = function() {
  var _observer = new Observer();
  var _val;
  return {
    subscribe: function(fn) {
      _observer.subscribe(fn);
    },
    unsubscribe: function(fn) {
      _observer.unsubscribe(fn);
    },
    fire: function(data) {
      _observer.fire(data);
    },
    setValue: function(val){
      _val = val;
    },
    getValue: function(){
      return _val
    }
  };
};

export const ShowMiniObserver = observer();

export const HideMiniObserver = observer();

export const ShowPlayerControlsObserver = observer();

export const HidePlayerControlsObserver = observer();

export const UpdateMiniObserver = observer();

export const UpdateMiniAfterRecordObserver = observer();

export const LetsPlayCatchup = observer();

export const recordFullObserver = observer();

export const RibbonsObserver = observer();

export const LiveObserver = observer();

export const FirstTimeShowModalPinObserver = observer();

export const AlreadyPlayChannelObserver = observer();

export const UpdateCardFromRibbonUserObserver = observer();

export const ADD_CARD = "ADD_CARD";

export const DELETE_CARD = "DELETE_CARD";

export const UPDATE_CARD = "UPDATE_CARD";

export const RecordingsNotification = observer();

export const HideMiniEpgFromNewPlayerControlsObserver = observer();



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/MiniObserver.js